import * as React from 'react'
import { A } from '../../styles/Elements'

interface WrapperProps {
  href?: string
  target?: string
}

const Wrapper: React.FC<WrapperProps> = ({ href, target, children }) => {
  if (href || target) {
    return (
      <A href={href} target={target}>
        {children}
      </A>
    )
  }

  return <>{children}</>
}

export default Wrapper
